import React from 'react';
import type { JSX, JSXElementConstructor, Ref } from 'react';

type FixedComponentProps<
  C extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>,
  P extends React.ComponentProps<C>,
> = P & { onFocusFix?: () => void; refFix?: Ref<any> };

type FixedComponent<
  C extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>,
  P extends React.ComponentProps<C>,
> = React.FunctionComponent<FixedComponentProps<C, P>>;

export default function asFix<
  C extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>,
  P extends React.ComponentProps<C>,
  T extends React.FunctionComponent<P>,
>(Component: T): FixedComponent<C, P> {
  return function (props: FixedComponentProps<C, P>) {
    return React.createElement<P>(Component, {
      ...props,
      ref: props.refFix ?? props.fix,
      onFocus: props.onFocusFix ?? props.onFocus,
    } as P);
  };
}
